module.exports = __webpack_public_path__ + "static/img/forget-by-email.89d10779.png";